import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { User } from '../models';
import { PayerResponse } from '../models/misc/payer-response';
import { ApicService } from '../services/apic.services';
import { AppState } from '../store/reducers';
import { selectUsersState } from '../store/reducers/users.reducer';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  appStatusCodes = {
    NO_RESULT: 204,
    RESULT_EXCEEDED: 422,
    NO_CONTENT: 204,
    CONSTRAINT_VIOLATION: 500,
    BAD_SEARCH: 400,
    DOCUMENT_DELETE_CPS: 400,
    DUPLICATE_CUST_ID: 400,
    FILE_EMPTY: 400,
    IDS: 500,
    INVALID_ORG: 400,
    INVALID_REQUEST: 400,
    TOKEN_EXPIRED: 400,
    MISMATCH_CLIENT_ID: 400,
    OKTA: 500,
    PASSWORD_RESET: 400,
    PAYER_EXCEPTION_BASE: 500,
    PAYER_PORTAL_SERVICE: 500,
    WEB_SERVICE_ERROR: 500,
    NOTIFICATION: 400,
  };

  tkn: string;
  user: User;
  publicPaths: string[] = ['ptk'];

  constructor(private store: Store<AppState>, private apicService: ApicService) {
    store.select(selectUsersState).pipe(takeUntilDestroyed()).subscribe(usersState => {
      this.user = usersState.user;
      this.tkn = usersState.tkn;
      this.publicPaths = usersState.publicPaths;
    });
  }

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let authReq = httpRequest.clone({
      headers: new HttpHeaders().set('X-IBM-Client-Id', this.apicService.xIBMClientId), withCredentials: true
    });

    if (httpRequest.url.indexOf('/payer-rest') !== -1) {
      authReq = httpRequest.clone({
        headers: new HttpHeaders().set('X-IBM-Client-Id', this.apicService.xIBMClientId)
          .set('PAYER-X-XSRF-TOKEN', this.tkn ? this.tkn : '')
          .set('PAYER-X-ID', this.user ? this.user?.userId.toString(16) : ''), withCredentials: true
      });
    }

    const response$ = next.handle(authReq);
    return this.mapReponse(response$);

  }

  mapReponse(response: Observable<HttpEvent<any>>): Observable<HttpEvent<any>> {
    return response.pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body && event.body.responseType) {
          const responseType = event.body.responseType;
          let httpStatusCode: any;
          let code = '---';
          // handle serve response three types: appStatusCode, prpStatusCode or prpStatusCodes
          if (responseType === 'appStatusCode') {
            code = event.body.code;
            httpStatusCode = this.appStatusCodes[code];

            if (httpStatusCode) {
              const newResponse = new HttpResponse({
                headers: event.headers,
                body: event.body.entity as HttpResponse<PayerResponse>, status: httpStatusCode, statusText: code
              });

              if (httpStatusCode < 400) return newResponse; else throw newResponse;

            }

          } else if (responseType === 'prpStatusCode' || responseType === 'prpStatusCodes') {
            throw new HttpErrorResponse({ headers: event.headers, error: event.body, status: 400, statusText: code });
          }
        }

        return event;
      }),
      catchError(err => {
        if (err.status === 404) {
          const newResponse = new HttpErrorResponse({ headers: err.headers, error: err.error, status: 500 });
          return throwError(() => newResponse);
        } else {
          return throwError(() => err);
        }
      }));
  }
}
